<template>
  <!-- <div> -->
  <!-- <a-card :bordered="false">-->

  <div id="charts">
    <a-row type="flex" :gutter="24">
      <a-col :span="18">
        <h6>กราฟรวมบอท {{ gameType }}</h6>
      </a-col>
    </a-row>

    <apexchart
      ref="realtimeChart"
      type="area"
      :height="height"
      :options="chartOptions"
      :series="series"
    />
    <ResultBoard
      ref="result_board"
      :gameType="gameType"
      v-if="gameType != 'ROULETTE' && resize == false"
    />
    <ResultBoardRoulette
      ref="result_board"
      :gameType="gameType"
      v-if="gameType == 'ROULETTE' && resize == false"
    />
  </div>
  <!-- </a-card>
  </div> -->
</template>

<script>
import ResultBoard from "./ResultBoard.vue";
import ResultBoardRoulette from "./ResultBoardRoulette.vue";

export default {
  name: "BrushCharts",
  components: {
    ResultBoard,
    ResultBoardRoulette,
  },

  props: {
    height: {
      type: Number,
      default: 170,
    },
    gameType: {
      type: String,
    },
    resize: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.getGameHistory(this.gameType);
  },
  data: function () {
    return {
      series: [
        {
          name: "DEFAULT",
          data: [],
        },
      ],
      chartOptions: {
        colors: ["#CC0001"],

        stroke: {
          dashArray: 4,
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0,
            stops: [0, 90, 100],
          },
        },
        chart: {
          height: 350,
          type: "area",
          toolbar: {
            show: false,
          },
          zoom: {
            autoScaleYaxis: true,
          },
        },

        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 3,
          dashArray: 0,
        },

        xaxis: {
          type: "category",
          labels: {
            show: false,
            align: "right",
            minWidth: 0,
            maxWidth: 160,
            style: {
              colors: "#8C8C8C",
            },
          },
        },
        yaxis: {
          show: true,
          showAlways: true,

          labels: {
            show: true,
            align: "right",
            minWidth: 0,
            maxWidth: 160,
            style: {
              colors: "#8C8C8C",
            },
          },
        },
        grid: {
          show: true,
          borderColor: "#8C8C8C1a",
          strokeDashArray: 0,
          position: "back",
          xaxis: {
            lines: {
              show: false,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
          row: {
            colors: undefined,
            opacity: 0.5,
          },
          column: {
            colors: undefined,
            opacity: 0.5,
          },
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },

        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm",
          },
        },
      },
      chartPointer: 0,
    };
  },

  methods: {
    generateDayWiseTimeSeries: function (baseval, count, yrange) {
      var i = 0;
      var series = [];
      while (i < count) {
        var x = baseval;
        var y =
          Math.floor(Math.random() * (yrange.max - yrange.min + 1)) +
          yrange.min;

        series.push([x, y]);
        baseval += 86400000;
        i++;
      }

      return series;
    },
    setResultBoard(val) {
      this.$refs.result_board.setPath(val);
    },
    addResultBoard(val) {
      this.$refs.result_board.addResult(
        val.roundStartTime != undefined
          ? { ...val, createdAt: val.roundStartTime }
          : val
      );
    },

    getGameHistory(val) {
      // this.chartPointer = 0;
      this.$http
        .get(
          `${process.env.VUE_APP_BACKEND_API_URL}/api/game/${val}/history?limit=50&isMock=${this.$store.getters.getMock}`
        )
        .then(({ data }) => {
          this.getChart(data);
        })
        .catch((err) => {
          return err;
        });
    },
    getChart(data) {
      this.chartOptions.xaxis.categories = [];
      this.chartOptions.xaxis.categories.push("");
      this.series[0].data = [];

      for (let i = data.length - 1; i >= 0; i--) {
        try {
          if (data[i].isWin !== undefined) {
            this.addChart(data[i], "PREDICTION");
            console.log(data[i]);
          }
        } catch (error) {
          console.log(error);
        }
      }
      this.updateSeriesLine();
    },

    addChart(val, tag) {
      if (val.isWin === null) {
        this.chartPointer += 0;
      } else {
        if (val.isWin) {
          this.chartPointer += 1;
        } else {
          this.chartPointer -= 1;
        }
      }

      let label =
        "" +
        "ฝั่งที่เล่น " +
        (this.gameType != "ROULETTE"
          ? val.prediction
          : val.prediction.playerType.toString()) +
        "<br>" +
        "ผลที่ออก " +
        (val.result != null ? val.result.winner : "เสมอ") +
        "<br>" +
        "ผลทำนาย " +
        (val.isWin === null ? "เสมอ" : val.isWin ? "ชนะ" : "แพ้") +
        "<br>เวลา " +
        new Date(
          tag === "PREDICTION" ? val.createdAt : val.roundStartTime
        ).toLocaleString("th-TH", {
          timeZone: "Asia/Bangkok",
        });

      this.series[0].data.push({
        x: label,
        y: this.chartPointer,
      });

      this.chartOptions.xaxis.categories.push(label);
    },

    updateSeriesLine() {
      this.$refs.realtimeChart.updateSeries(
        [
          {
            data: this.series[0].data,
          },
        ],
        false,
        true
      );
    },
  },
};
</script>

<style scoped>
#charts {
  /* background-image: linear-gradient(to right, #1890ff, #1890ff, #1890ff); */
  border-radius: 8px;
}
</style>
